import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberBadgeDto, PermissionDto } from '@careapp-group/ng-sdk-v2-new';

/**
 * Badge Wrapper
 * Wrap this component around a ca-avatar to display a badge overlay.
 * Will display the first found badge.
 */
@Component({
  selector: 'ca-badge-wrapper',
  templateUrl: './badge-wrapper.component.html',
  styleUrls: ['./badge-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeWrapperComponent {
  badge: MemberBadgeDto;

  @Input() set permissions(permissions: PermissionDto[]) {
    this.updateBadge(permissions);
  }

  // Apply the first badge found.
  private updateBadge(permissions: PermissionDto[]): void {
    this.badge = null;
    if (!!permissions && Array.isArray(permissions)) {
      for (const permission of permissions ?? []) {
        for (const badge of permission.badges ?? []) {
          this.badge = badge;
          return;
        }
      }
    }
  }

  @Input()
  small: boolean;

  @Input()
  chip: boolean;
}
